import Vue from 'vue'
import Vuex from 'vuex'
import { _axios } from '@/plugins/axios'
import { i18n } from '@/plugins/i18n'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    population: '',
    snackbar: {
      display: false,
      color: 'cyan darken-2',
      message: '',
    },
    submission: false,
  },
  getters: {
    population: state => state.population,
    snackbar: state => state.snackbar,
    snackbarDisplayed: state => state.snackbar.display,
    submission: state => state.submission,
  },
  actions: {
    setPopulation: ({ commit }, newValue) => {
      commit('SET_POPULATION', newValue)
    },
    switchSnackbarStatus: ({ commit }, newStatus) => {
      commit('SNACKBAR_STATUS', newStatus)

      if (!newStatus) {
        commit('SNACKBAR_MESSAGE', '')
      }
    },
    postFormValues: ({ commit }, payload) => {
      let full = {
        'formId': process.env.VUE_APP_FORM_ID,
        'versionId': process.env.VUE_APP_VERSION_ID,
        'answers': payload,
      }

      commit('SUBMISSION_SWITCH', true)

      return _axios.post(`/submissions/handle_submission/`, full)
    },
    postFormValuesValidation: ({commit}, { mail }) => {
      commit('SNACKBAR_MESSAGE', i18n.t('snackbare.valid', { mail }))
      commit('SNACKBAR_TYPE', 'valid')
      commit('SNACKBAR_STATUS', true)
      commit('SUBMISSION_SWITCH', false)
    },
    postFormValuesError: ({commit}) => {
      commit('SNACKBAR_MESSAGE', i18n.t('snackbare.error'))
      commit('SNACKBAR_TYPE', 'error')
      commit('SNACKBAR_STATUS', true)
      commit('SUBMISSION_SWITCH', false)
    }
  },
  mutations: {
    SET_POPULATION: (state, newValue) => {
      state.population = newValue
    },
    SNACKBAR_MESSAGE: (state, newMessage) => {
      state.snackbar.message = newMessage
    },
    SNACKBAR_STATUS: (state, newStatus) => {
      state.snackbar.display = newStatus
    },
    SNACKBAR_TYPE: (state, newType) => {
      state.snackbar.color = newType === 'error' ? 'red darken-2' : 'cyan darken-2'
    },
    SUBMISSION_SWITCH: (state, newStatus) => {
      state.submission = newStatus
    },
  },
})
